var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.377 31.952v51.385c0 4.785-3.879 8.664-8.664 8.664h-53.427c-4.785 0-8.664-3.879-8.664-8.664v-70.673c.001-4.785 3.879-8.664 8.664-8.664h35.784z",
    fill: "#bf4565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.377 31.952h-20.531c-3.19 0-5.776-2.586-5.776-5.776v-22.176z",
    fill: "#ed7298"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.489 66.861h-5.697l-.998 3.221h-4.439l6.323-17.243h3.909l6.374 17.243h-4.467zm-4.704-3.21h3.706l-1.856-5.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.994 65.394 3.435-12.556h4.648l-5.804 17.243h-4.552l-5.753-17.243h4.608z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.756 70.082h-4.146v-17.243h4.146z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvi);
export default __webpack_public_path__ + "static/media/avi.f6601d71c32343ae41a07dbfd55d7a96.svg";
export { ForwardRef as ReactComponent };